var scope_0 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/06c1a8f676b6ceb759515039f6b04322.js').default;
var scope_1 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/29cf6b9a372fb40bd5c9cd2d88dae2e6.js').default;
var scope_2 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2f8f85d9b812fb28688cef9ea0415a88.js').default;
var scope_3 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3d289a98b7ac2367a1043353e07478bf.js').default;
var scope_4 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/56536ab0f706ec63cfe14081f73a1004.js').default;
var scope_5 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/61efc108d282e359d91c6e3a2faa80b3.js').default;
var scope_6 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ffc8e96d0e654f10becb31163e0b851.js').default;
var scope_7 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b57388485de1d0df12f48b498950c164.js').default;
var scope_8 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bd9ed2c10bc9706a9817b2fe8570b122.js').default;
var scope_9 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c9704292c74b34a61697606d33a4206a.js').default;
var scope_10 = require('/vercel/path0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10 )
    